import { useWebVitals } from '@app/hooks/useWebVitals';

const WebVitalsReporter = () => {
  useWebVitals();
  return null;
};

export default WebVitalsReporter;
